import { useCountryContext } from "app/context/country.context";
import { useGoBackEvent } from "app/hooks/go-back.hook";
import { useArrowKeyNavigationOverlay } from "app/hooks/keyboard-navigation.hook";
import { useTranslate } from "app/hooks/lang";
import useModalScroll from "app/hooks/modal-scroll.hook";
import { localesMap } from "app/utils/localesMap";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { BackButtonBar } from "../back-button/back-button.component";
import styles from "./locale-selector.module.scss";

interface LocaleSelectorProps {
  onClose: VoidFunction;
}
export const LocaleSelector: React.FC<LocaleSelectorProps> = ({ onClose }) => {
  const wrapperRef = useArrowKeyNavigationOverlay();
  useModalScroll();
  const goBackCallback = useCallback(() => {
    onClose();
  }, [onClose]);
  useGoBackEvent("LocaleSelector", goBackCallback);
  const { setLocaleOverride } = useCountryContext();
  const router = useRouter();
  const t = useTranslate();
  const { asPath, query, locales } = router;
  const userLocales = locales?.filter((item) => !!localesMap[item]) || [];

  return (
    <div className={styles.popup_wrapper} ref={wrapperRef}>
      <div className={styles.content}>
        <BackButtonBar onClick={onClose} />
        <div className={styles.locale_selector}>
          <h2 className={styles.header}>
            {t("settings.select-application-language")}
          </h2>
          {userLocales?.map((locale) => (
            <div
              className={styles.locale}
              data-navigate-row
              key={`locale-${locale}`}
            >
              <button
                className={styles.locale_btn}
                data-navigate-item
                onClick={() => {
                  setLocaleOverride(locale);
                  router.push(
                    { pathname: `${locale}/pathname`, query },
                    asPath,
                    {
                      locale,
                    }
                  );
                  onClose();
                }}
              >
                {localesMap[locale]}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
